export const CALL_EXTENSION_ID = 'fdjkimokpckkgbcmdifdcacinhhgcefb';
